export const CUSTOMER_NATIONALITY_OPTIONS = [
  'Japanese',
  'Cambodian',
  'Chinese',
  'Taiwanese',
  'Korean',
  'Hong Konger',
  'Thai',
  'Vietnamese',
  'Lao',
  'Myanmar',
  'Malaysian',
  'Singaporean',
  'Indonesian',
  'Filipino',
  'Bruneian',
  'Indian',
  'Other Asian',
  'Westerners',
] as const;

export type CustomerNationalityOption = (typeof CUSTOMER_NATIONALITY_OPTIONS)[number];
